<div
  class="datetime"
  [ngClass]="variantClass"
  [class.datetime__timezone]="isTimezoneSelectionEnabled && isLive"
>
  <!-- start date -->
  <app-form-control
    class="datetime__date"
    [label]="dateLabel"
    [errorMessages]="dateErrorMessages"
  >
    <ng-container custom-label>
      <ng-content select="[custom-date-label]"></ng-content>
    </ng-container>

    <app-form-input
      #controlChild
      [type]="inputDateType"
      [min]="minDate"
      [max]="maxDate"
      [tabindex]="tabindex"
      [formControl]="date"
      [placeholder]="!isInputDateSupported ? datePlaceholder : null"
      [hasError]="date?.touched && date?.invalid"
    ></app-form-input>
  </app-form-control>

  <!-- start time -->
  <app-form-control
    class="datetime__time"
    [label]="dateLabel"
    [errorMessages]="timeErrorMessages"
  >
    <ng-container custom-label>
      <ng-content select="[custom-time-label]"></ng-content>
    </ng-container>

    <app-form-input
      #controlChild
      [type]="inputTimeType"
      [min]="minTime"
      [max]="maxTime"
      [tabindex]="tabindex"
      [formControl]="time"
      [placeholder]="!isInputTimeSupported ? timePlaceholder : null"
      [hasError]="time?.touched && time?.invalid"
    ></app-form-input>
  </app-form-control>
</div>
<!-- select timezone -->
<app-form-control
  *ngIf="isTimezoneSelectionEnabled && isLive"
  [label]="timezoneLabel"
  [errorMessages]="timezoneErrorMessage"
>
  <ng-container custom-label>
    <ng-content select="[custom-timezone-label]"></ng-content>
  </ng-container>

  <app-form-autocomplete
    #controlChild
    [formControl]="timezone"
    [autoFilter]="true"
    [suggestions]="timezones"
    [triggerText]="timezone.value"
    [required]="true"
  ></app-form-autocomplete>
</app-form-control>
